var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcUnit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6673_4375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6673_4375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 18.3333V14.875L6.45829 17.5416L5.29163 16.375L9.16663 12.5V10.8333H7.49996L3.62496 14.7083L2.45829 13.5416L5.12496 10.8333H1.66663V9.16663H5.12496L2.45829 6.45829L3.62496 5.29163L7.49996 9.16663H9.16663V7.49996L5.29163 3.62496L6.45829 2.45829L9.16663 5.12496V1.66663H10.8333V5.12496L13.5416 2.45829L14.7083 3.62496L10.8333 7.49996V9.16663H12.5L16.375 5.29163L17.5416 6.45829L14.875 9.16663H18.3333V10.8333H14.875L17.5416 13.5416L16.375 14.7083L12.5 10.8333H10.8333V12.5L14.7083 16.375L13.5416 17.5416L10.8333 14.875V18.3333H9.16663Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcUnit);
export default __webpack_public_path__ + "static/media/ac_unit.c252d1d7b5564844e570ecf1144f0254.svg";
export { ForwardRef as ReactComponent };